<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent" style="display: contents"></app-loading-state>
<ng-template #loadedContent>
	<div class="offcanvas-header">
		<div class="left">
			<div class="status-icon" [style.background-color]="getScheduledAssessmentColour(scheduledAssessment.status)"></div>
			<h3 class="offcanvas-title">
				Job Card
				<div class="header-subtitle">Employee: {{ scheduledAssessment.assignedEmployee.name }}</div>
			</h3>
		</div>
		<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
	</div>
	<hr class="mx-3" />
	<div class="offcanvas-body">
		<div class="body">
			<ng-container *ngIf="jobCardActive">
				<app-alert
					[alertType]="AlertTypes.WARNING"
					content="Job Card is still active. Please complete the job card before signing off."
					alertIcon="bi-exclamation-triangle"
					[dismissible]="true"
				>
				</app-alert>
			</ng-container>
			<div class="column-item">
				<h5>Job Description</h5>
				<small>
					{{ assessmentDetails.jobDescription || 'Not Available' }}
				</small>
			</div>
			<div class="column-item">
				<h5>Date & Time</h5>
				<small>
					{{ scheduledTime }}
				</small>
			</div>
			<div class="column-item">
				<h5>Job Notes</h5>
				<small>
					{{ jobCard.notes || 'Not Available' }}
				</small>
			</div>
			<div class="column-item">
				<h5>Materials Used</h5>
				<ng-container *ngIf="jobCard.materials?.length; else noMaterials">
					<ng-container *ngFor="let material of jobCard.materials">
						<small> {{ material.quantity }} x {{ material.description }} </small>
					</ng-container>
				</ng-container>
				<ng-template #noMaterials> No materials used </ng-template>
			</div>
			<div class="column-item">
				<h5>Attachments</h5>
				<ng-container *ngIf="attachments.length; else noAttachments">
					<div class="attachments-wrapper">
						<ng-container *ngFor="let attachment of filteredAttachments; let i = index">
							<app-job-card-attachment [attachment]="attachment" [readonly]="true"></app-job-card-attachment>
						</ng-container>
					</div>
				</ng-container>
				<ng-template #noAttachments> No attachments uploaded </ng-template>
			</div>
		</div>

		<div class="footer">
			<div class="actions">
				<ng-container *ngIf="!jobCardActive; else jobCardIsActive">
					<app-job-card-signature
						[scheduledAssessment]="scheduledAssessment"
						[scheduledAssessmentId]="scheduledAssessmentId"
						(signatureSaved)="signatureSaved($event)"
					></app-job-card-signature>
				</ng-container>
				<ng-template #jobCardIsActive>
					<em>Once the job card is complete, you will be able to sign off</em>
				</ng-template>
			</div>
		</div>
	</div>
</ng-template>
